import {
  DownloadTransferResponseRaw,
  OwnedTransferItem,
  OwnedTransferResponseRaw,
} from '../types/transfers';
import {
  FileCollection,
  RecipientCollection,
  Transfer,
  TransferState,
} from '@wetransfer/transfer/types/graphql-types';

import { normalizeTransfer } from './normalize-transfer';

// Helper to convert API Transfer model to GraphQL version of a transfer.
// It's used to add transfer to Transfer List right after upload using API response.
export const transformTransferAPIToGraphQL = (
  transfer: OwnedTransferResponseRaw & DownloadTransferResponseRaw
): Transfer => {
  const newTransfer = {} as Transfer;

  const normalizedTransfer = normalizeTransfer(transfer);

  newTransfer.id = transfer.id;
  newTransfer.createdAt = transfer.uploaded_at;
  newTransfer.downloadCount = transfer.number_of_downloads;
  newTransfer.expiresAt = transfer.expires_at;
  newTransfer.files = {
    totalCount: transfer.files.length,
    collection: transfer.files.map((file: OwnedTransferItem) => {
      return {
        id: file.id,
        name: file.name,
        size: file.size,
        type: file.item_type,
      };
    }),
  } as FileCollection;
  newTransfer.from = normalizedTransfer.from;
  newTransfer.message = transfer.message;
  newTransfer.name = transfer.display_name;
  newTransfer.paid = normalizedTransfer.paid;
  newTransfer.product = null;
  newTransfer.passwordProtected = transfer.password_protected;
  newTransfer.recipients = {
    totalCount: normalizedTransfer.recipients.length,
    collection: normalizedTransfer.recipients.map((recipient) => {
      return {
        downloaded: recipient.transfer_downloaded,
        email: recipient.email,
      };
    }),
  } as RecipientCollection;
  newTransfer.securityHash = transfer.security_hash;
  newTransfer.sender = {
    avatarUrl: '',
    email: normalizedTransfer.sender || '',
    givenName: '',
  };
  newTransfer.shortenedUrl = transfer.shortened_url;
  newTransfer.state = transfer.state as TransferState;
  newTransfer.totalFileSize = transfer.size;
  newTransfer.uploadedAt = transfer.uploaded_at;
  newTransfer.__typename = 'Transfer';

  return newTransfer;
};
